import { render, staticRenderFns } from "./LoadingListView.vue?vue&type=template&id=48753caa"
import script from "./LoadingListView.vue?vue&type=script&lang=ts"
export * from "./LoadingListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports